import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useMemo } from 'react';
import { useApolloClient, useQuery } from '@apollo/client';
import { GET_CART, GET_CLOSEST_STORES_FROM_ZIPCODE } from 'mocks/queries';
import { ZIP_CODE_REGEX, ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import { logError } from 'commons/logger';
import { isPhysicalShowroom } from 'components/consumer/StoreLocatorPage/helpers';
import useSetZipCodeFromUser from 'global-state/zipCodeFromUser/useSetZipCodeFromUser';
const EMPTY_STORES = [];
export const validateZipcodeInput = inputs => {
  if (!inputs.zipcode.toString().trim()) {
    return {
      zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY
    };
  }
  if (!ZIP_CODE_REGEX.test(inputs.zipcode)) {
    return {
      zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT
    };
  }
  return {};
};
const useShowroomLocator = t0 => {
  const $ = _c(21);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    limit: t2
  } = t1;
  const limit = t2 === undefined ? 10 : t2;
  const apolloClient = useApolloClient();
  const [searchZipcode, setSearchZipcode] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const setZipCodeFromUser = useSetZipCodeFromUser();
  let t3;
  if ($[2] !== limit || $[3] !== searchZipcode) {
    t3 = {
      zipcode: searchZipcode,
      limit
    };
    $[2] = limit;
    $[3] = searchZipcode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !hasSearched || !searchZipcode;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = {
      variables: t3,
      skip: t4,
      errorPolicy: "all"
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data,
    loading,
    error
  } = useQuery(GET_CLOSEST_STORES_FROM_ZIPCODE, t5);
  const rawStores = data?.getClosestStoresFromZipcode || EMPTY_STORES;
  let t6;
  if ($[8] !== rawStores) {
    t6 = rawStores.filter(_temp);
    $[8] = rawStores;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const stores = t6;
  let t7;
  if ($[10] !== apolloClient || $[11] !== setZipCodeFromUser) {
    t7 = zipcode => {
      const trimmedZipCode = zipcode.trim();
      setSearchZipcode(trimmedZipCode);
      setHasSearched(true);
      setZipCodeFromUser(trimmedZipCode);
      apolloClient.refetchQueries({
        include: [GET_CART]
      }).catch(_temp2);
    };
    $[10] = apolloClient;
    $[11] = setZipCodeFromUser;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleSearch = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setHasSearched(false);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleCloseResults = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setSearchZipcode("");
      setHasSearched(false);
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const handleViewAll = t9;
  let t10;
  if ($[15] !== error || $[16] !== handleSearch || $[17] !== hasSearched || $[18] !== loading || $[19] !== stores) {
    t10 = {
      stores,
      loading,
      error,
      hasSearched,
      handleSearch,
      handleCloseResults,
      handleViewAll
    };
    $[15] = error;
    $[16] = handleSearch;
    $[17] = hasSearched;
    $[18] = loading;
    $[19] = stores;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default useShowroomLocator;
function _temp(row) {
  return isPhysicalShowroom(row?.storeData);
}
function _temp2(refetchError) {
  logError(refetchError, "Failed to refetch GET_CART after showroom zip search");
}